import(/* webpackMode: "eager" */ "/home/bas/app_7ff143f5-d243-4c37-a599-c1a6b8f00185/frontend/src/app/[locale]/error.tsx");
